import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { API_BASE_URL } from '../config/apiconfig';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [verifying, setVerifying] = useState(false);
  const [ok, setOk] = useState(false);
  const [message, setMessage] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    const t = searchParams.get('token');
    if (!t) {
      setMessage('Missing verification token.');
      setOk(false);
      return;
    }
    setToken(t);
    setMessage('Click the button below to verify your account.');
  }, [searchParams]);

  const handleVerify = async () => {
    if (!token) return;
    setVerifying(true);
    setMessage('');
    try {
      const res = await fetch(`${API_BASE_URL}/api/verify-email?token=${encodeURIComponent(token)}`);
      const data = await res.json();
      if (res.ok) {
        setOk(true);
        setMessage(data.message || 'Email verified successfully.');
        setShowSuccessModal(true);
      } else {
        setOk(false);
        setMessage(data.error || 'Verification failed.');
      }
    } catch (e) {
      setOk(false);
      setMessage('Network error. Try again later.');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="flex-1 flex items-center justify-center bg-gray-50 p-6">
        <div className="w-full max-w-md rounded-2xl p-8 shadow bg-white">
          <div className="space-y-4 text-center">
            <h1 className="text-2xl font-semibold">Email Verification</h1>
            {message && <p className="text-gray-600">{message}</p>}
            <div className="mt-4">
              <button
                onClick={handleVerify}
                disabled={verifying || !token}
                className="inline-flex items-center justify-center px-5 py-3 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
              >
                {verifying ? 'Verifying...' : 'Verify Account'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 text-center">
            <h3 className="text-xl font-semibold mb-2">Email Verified</h3>
            <p className="text-gray-600">Your account has been verified successfully. You can now log in.</p>
            <div className="mt-6 flex justify-center">
              <button onClick={() => navigate('/login')} className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700">Go to Login now</button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default VerifyEmail;
